// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanTaskMaterialsPageQueryVariables = Types.Exact<{
  taskId: Types.Scalars['ID']['input'];
}>;


export type PlanTaskMaterialsPageQuery = { __typename?: 'Query', planTask: { __typename?: 'PlanTask', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, quantity?: number | null | undefined, costType: Types.CostType, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, division: { __typename?: 'CostDivision', id: string, name: string } } }, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
        | { __typename?: 'ItemTemplateItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
        | { __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
        | { __typename?: 'TakeoffLineItemVersion', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
       | null | undefined, currentTradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }>, schedule: { __typename?: 'PlanSchedule', id: string, parent:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
       }, globalPlanTask: { __typename?: 'GlobalPlanTask', id: string, drops: Array<{ __typename?: 'Drop', id: string, name: string }> } } };

export type TaskMaterialsPage_PlanTaskFragment = { __typename?: 'PlanTask', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, quantity?: number | null | undefined, costType: Types.CostType, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, division: { __typename?: 'CostDivision', id: string, name: string } } }, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
      | { __typename?: 'ItemTemplateItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
      | { __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
      | { __typename?: 'TakeoffLineItemVersion', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
     | null | undefined, currentTradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }>, schedule: { __typename?: 'PlanSchedule', id: string, parent:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     }, globalPlanTask: { __typename?: 'GlobalPlanTask', id: string, drops: Array<{ __typename?: 'Drop', id: string, name: string }> } };

export type TaskMaterialsPage_ProjectItemFragment = { __typename?: 'ProjectItem', id: string, name: string, quantity?: number | null | undefined, costType: Types.CostType, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, division: { __typename?: 'CostDivision', id: string, name: string } } }, itemTemplateItem?:
    | { __typename?: 'ItemTemplateItemVersion', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
    | { __typename?: 'ItemTemplateItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
    | { __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
    | { __typename?: 'TakeoffLineItemVersion', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined } | null | undefined } | null | undefined }
   | null | undefined, currentTradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined };

export const TaskMaterialsPage_ProjectItemFragmentDoc = gql`
    fragment TaskMaterialsPage_ProjectItem on ProjectItem {
  id
  name
  quantity
  costType
  item {
    id
    costCode {
      id
      division {
        id
        name
      }
    }
  }
  itemTemplateItem {
    id
    materialVariant {
      id
      code
      modelNumber
      featuredImage {
        id
        asset {
          id
          downloadUrl
        }
      }
    }
  }
  currentTradePartner {
    id
    name
  }
}
    `;
export const TaskMaterialsPage_PlanTaskFragmentDoc = gql`
    fragment TaskMaterialsPage_PlanTask on PlanTask {
  id
  name
  projectItems {
    ...TaskMaterialsPage_ProjectItem
  }
  schedule {
    id
    parent {
      ... on Project {
        id
        name
      }
    }
  }
  globalPlanTask {
    id
    drops {
      id
      name
    }
  }
}
    ${TaskMaterialsPage_ProjectItemFragmentDoc}`;
export const PlanTaskMaterialsPageDocument = gql`
    query PlanTaskMaterialsPage($taskId: ID!) {
  planTask(id: $taskId) {
    ...TaskMaterialsPage_PlanTask
  }
}
    ${TaskMaterialsPage_PlanTaskFragmentDoc}`;

/**
 * __usePlanTaskMaterialsPageQuery__
 *
 * To run a query within a React component, call `usePlanTaskMaterialsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanTaskMaterialsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanTaskMaterialsPageQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function usePlanTaskMaterialsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables> & ({ variables: PlanTaskMaterialsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>(PlanTaskMaterialsPageDocument, options);
      }
export function usePlanTaskMaterialsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>(PlanTaskMaterialsPageDocument, options);
        }
// @ts-ignore
export function usePlanTaskMaterialsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>;
export function usePlanTaskMaterialsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanTaskMaterialsPageQuery | undefined, PlanTaskMaterialsPageQueryVariables>;
export function usePlanTaskMaterialsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>(PlanTaskMaterialsPageDocument, options);
        }
export type PlanTaskMaterialsPageQueryHookResult = ReturnType<typeof usePlanTaskMaterialsPageQuery>;
export type PlanTaskMaterialsPageLazyQueryHookResult = ReturnType<typeof usePlanTaskMaterialsPageLazyQuery>;
export type PlanTaskMaterialsPageSuspenseQueryHookResult = ReturnType<typeof usePlanTaskMaterialsPageSuspenseQuery>;
export type PlanTaskMaterialsPageQueryResult = Apollo.QueryResult<PlanTaskMaterialsPageQuery, PlanTaskMaterialsPageQueryVariables>;